import axios from 'axios';
import { geenVerbinding, GEEN_VERBINDING } from './verbinding';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8009';

// Laravel has no /scan: GET /status tells whether a code can still be approved.
// Shared by QrApprove (phone camera opens /qr/<code>) and QrScanner (in-app
// camera) -- the scanner kept calling the removed /scan and got a 404 on every
// code (20-10-2026).
export async function qrStatus(code) {
  const response = await axios.get(`${API_URL}/api/auth/qr/${code}/status`);
  return {
    status: response.data?.status,
    deviceInfo: response.data?.deviceInfo ?? null,
  };
}

// Laravel answers errors with `message`, older endpoints with `error`. No answer at all
// means no connection, not a bad code.
export function serverFout(err, fallback) {
  if (geenVerbinding(err)) return GEEN_VERBINDING;
  return err.response?.data?.error || err.response?.data?.message || fallback;
}
